import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { Input } from 'components/shared/Input';

const PriceInput = ({
  inputRef,
  maskOptions,
  ...restProps
}: {
  inputRef: any;
  maskOptions: any;
} & Record<string, any>) => {
  return (
    <MaskedInput
      {...restProps}
      {...(maskOptions ? { mask: createNumberMask(maskOptions) } : {})}
      render={(ref: any, props: any) => (
        <Input
          {...props}
          inputRef={(element: any) => {
            ref(element);

            if (inputRef) {
              inputRef.current = element;
            }
          }}
        />
      )}
    />
  );
};

export default React.memo(PriceInput) as any;
